import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import SimpleHeaderWithBackBtn from "./SimpleHeaderWithBackBtn";

const Header = () => {

	const { isMobile } = useSelector(state => state.general);

    return (

        <Routes>
            <Route  path='fa/product/*' element={ !isMobile ? <SimpleHeaderWithBackBtn /> : <SimpleHeaderWithBackBtn />} />
            <Route  path='en/product/*' element={ !isMobile ? <SimpleHeaderWithBackBtn /> : <SimpleHeaderWithBackBtn />} />
        </Routes>

    );
}

export default Header;